import React from 'react';
import { Box } from '../../shared/components';

export default function Page({ children, ...rest }) {
  return (
    <Box {...rest} className="ejemploPagina">
      {children}
    </Box>
  );
}
